/* eslint-disable max-lines */
import { IntegrationKinds } from '@recruitee/integrations/types';

import { AdpIntegration } from '../integrations/adp/types';
import { AfasIntegration } from '../integrations/afas/types';
import { AppicalIntegration } from '../integrations/appical/types';
import { BambooIntegration } from '../integrations/bamboo/types';
import { BryqIntegration } from '../integrations/bryq/types';
import { CheckrIntegration } from '../integrations/checkr/types';
import { CodilityIntegration } from '../integrations/codility/types';
import { DevSkillerIntegration } from '../integrations/dev-skiller/types';
import { DocuSignIntegration } from '../integrations/docu-sign/types';
import { EnboarderIntegration } from '../integrations/enboarder/types';
import { ESkillIntegration } from '../integrations/eskill/types';
import { GfeaIntegration } from '../integrations/gfea/types';
import { GustoIntegration } from '../integrations/gusto/types';
import { HackerRankIntegration } from '../integrations/hacker-rank/types';
import { HarverIntegration } from '../integrations/harver/types';
import { HelloSignIntegration } from '../integrations/hello-sign/types';
import { HibobIntegration } from '../integrations/hibob/types';
import { HotelprofessionalsIntegration } from '../integrations/hotelprofessionals/types';
import { Hr2dayIntegration } from '../integrations/hr2day/types';
import { IndeedIntegration } from '../integrations/indeed/types';
import { InterviewMochaIntegration } from '../integrations/interview-mocha/types';
import { JacandoIntegration } from '../integrations/jacando/types';
import { JitsiIntegration } from '../integrations/jitsi/types';
import { JobCampaignsIntegration } from '../integrations/job-campaigns/types';
import { KiwiHrIntegration } from '../integrations/kiwi-hr/types';
import { KununuIntegration } from '../integrations/kununu/types';
import { LuccaIntegration } from '../integrations/lucca/types';
import { NmbrsIntegration } from '../integrations/nmbrs/types';
import { OfficientIntegration } from '../integrations/officient/types';
import { PartnerIntegration } from '../integrations/partner/types';
import { PersonioIntegration } from '../integrations/personio/types';
import { PredictiveIndexIntegration } from '../integrations/predictive-index/types';
import { SignRequestIntegration } from '../integrations/sign-request/types';
import { SympaIntegration } from '../integrations/sympa/types';
import { TeamsIntegration } from '../integrations/teams/types';
import { TestDomeIntegration } from '../integrations/test-dome/types';
import { TyomarkkinatoriIntegration } from '../integrations/tyomarkkinatori/types';
import { WerkenInEenHotelIntegration } from '../integrations/werken-in-een-hotel/types';
import { ZoomIntegration } from '../integrations/zoom/types';

export const ALL_INTEGRATION_KINDS = [
  IntegrationKinds.ADP,
  IntegrationKinds.HR2DAY,
  IntegrationKinds.TYOMARKKINATORI,
  IntegrationKinds.HACKER_RANK,
  IntegrationKinds.JITSI,
  IntegrationKinds.DEV_SKILLER,
  IntegrationKinds.OFFICIENT,
  IntegrationKinds.ESKILL,
  IntegrationKinds.GUSTO,
  IntegrationKinds.KIWI_HR,
  IntegrationKinds.JACANDO,
  IntegrationKinds.KUNUNU,
  IntegrationKinds.ACME,
  IntegrationKinds.WONDERKIND,
  IntegrationKinds.TEAMS,
  IntegrationKinds.HARVER,
  IntegrationKinds.INDEED,
  IntegrationKinds.PREDICTIVE_INDEX,
  IntegrationKinds.DOCU_SIGN,
  IntegrationKinds.HELLO_SIGN,
  IntegrationKinds.SIGN_REQUEST,
  IntegrationKinds.GOOGLE_HANGOUTS_MEET,
  IntegrationKinds.ZOOM,
  IntegrationKinds.LUCCA,
  IntegrationKinds.NMBRS,
  IntegrationKinds.ENBOARDER,
  IntegrationKinds.HOTELPROFESSIONALS,
  IntegrationKinds.HIBOB,
  IntegrationKinds.WERKEN_IN_EEN_HOTEL,
  IntegrationKinds.APPICAL,
  IntegrationKinds.BRYQ,
  IntegrationKinds.INTERVIEW_MOCHA,
  IntegrationKinds.TEST_DOME,
  IntegrationKinds.CODILITY,
  IntegrationKinds.PERSONIO,
  IntegrationKinds.BAMBOO,
  IntegrationKinds.CHECKR,
];

export type IntegrationUnion =
  | PartnerIntegration
  | AdpIntegration
  | Hr2dayIntegration
  | TyomarkkinatoriIntegration
  | HackerRankIntegration
  | JitsiIntegration
  | DevSkillerIntegration
  | OfficientIntegration
  | ESkillIntegration
  | GustoIntegration
  | KiwiHrIntegration
  | JacandoIntegration
  | AfasIntegration
  | GfeaIntegration
  | SympaIntegration
  | KununuIntegration
  | JobCampaignsIntegration
  | TeamsIntegration
  | HarverIntegration
  | IndeedIntegration
  | PredictiveIndexIntegration
  | DocuSignIntegration
  | HelloSignIntegration
  | SignRequestIntegration
  | ZoomIntegration
  | LuccaIntegration
  | NmbrsIntegration
  | EnboarderIntegration
  | HotelprofessionalsIntegration
  | HibobIntegration
  | WerkenInEenHotelIntegration
  | AppicalIntegration
  | BryqIntegration
  | InterviewMochaIntegration
  | TestDomeIntegration
  | CodilityIntegration
  | PersonioIntegration
  | BambooIntegration
  | CheckrIntegration;
